import Vue from 'vue'
import Vuex from 'vuex'

import {resetRouter} from '@/router'
import {getToken, setToken, removeToken} from '@/utils/auth'
import {getYear, setYear} from '@/utils/year'

import {login} from '@/api/user.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: getToken(), // token信息
        year: getYear(), // 选择年份
        showLoading: false // 是否显示loading
    },
    mutations: {
        setLogin(state, data) { // 设置登录
            state.token = data
        },
        loginOut(state) { // 退出登录
            state.token = ''
        },
        setYear(state, data) { // 设置年份
            state.year = data
        },
        setLoading(state, data) { // 设置loading
            state.showLoading = data
        }
    },
    actions: {
        setLogin({commit}, userInfo) { // 登录
            return new Promise((resolve, reject) => {
                login(userInfo).then(res => {
                    commit('setLogin', res.data)
                    setToken(res.data)
                    resetRouter()
                    resolve()
                }).catch(err => {
                    reject(err.Error)
                })
            })
        },
        loginOut({commit}) { // 退出登录
            return new Promise((resolve, reject) => {
                removeToken()
                resetRouter()
                commit('loginOut')
                resolve()
            })
        },
        setYear({commit}, year) { // 设置年份
            commit('setYear', year)
            setYear(year)
        },
        setLoading({commit}, isShow) { // 设置loading
            commit('setLoading', isShow)
        }
    },
    modules: {}
})
